import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button, Divider, Space } from "antd";
import "../Login/Login.scss";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../Login/redux";
import { emailLoadingSelector } from "../Login/selector";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";

const QRCodeLogin = (props) => {
  const dispatch = useDispatch();
  const loading = useSelector(emailLoadingSelector);
  const mrIntl = useTranslate();
  const videoRef = useRef(null);
  const [cameraError, setCameraError] = useState(false);
  const [scanning, setScanning] = useState(true);
  const history = useHistory();

  useEffect(() => {
    startCamera();
    
    // Add event listener for route changes
    const unlisten = history.listen(() => {
      stopCamera();
    });
    
    return () => {
      stopCamera();
      unlisten(); // Clean up the listener when component unmounts
    };
  }, [history]);

  const startCamera = async () => {
    try {
      const constraints = {
        video: {
          facingMode: "environment"
        }
      };
      
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
      setCameraError(false);
    } catch (error) {
      console.error("Error accessing camera:", error);
      setCameraError(true);
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const handleQRCodeDetected = (qrCode) => {
    // Here you would dispatch an action to verify the QR code
    console.log("QR code detected:", qrCode);
    
    // Example dispatch - replace with actual implementation
    // dispatch(
    //   actions.qrCodeLogin(qrCode, {
    //     success: {
    //       showMessage: true,
    //       message: mrIntl("QRCodeLogin.login_successful") || "Login successful",
    //     },
    //   })
    // );
    
    // Stop camera before redirecting
    stopCamera();
    
    // For now, we'll just redirect to home page after a simulated "success"
    setTimeout(() => {
      window.location.href = "/";
    }, 1000);
  };


  return (
    <div className={"forgot-pass-main auth-form-container"}>
      <h3>{mrIntl("QRCodeLogin.qr_code_login") || "Login with QR Code"}</h3>
      <p className="text-center">{mrIntl("QRCodeLogin.hold_up_badge") || "Hold up the QR code badge to the camera"}</p>
      
      <div className="qr-scanner-container">
        <div className="qr-scanner-frame" style={{ border: '2px dashed #ccc', borderRadius: '8px' }}>
          <video 
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }}
            onPlay={() => setScanning(true)}
          />
          <div className="qr-scanner-corner top-left"></div>
          <div className="qr-scanner-corner top-right"></div>
          <div className="qr-scanner-corner bottom-left"></div>
          <div className="qr-scanner-corner bottom-right"></div>
          <div className="qr-scanner-center-circle"></div>
        </div>
        
        {cameraError && (
          <p className="camera-error">
            {mrIntl("QRCodeLogin.check_camera_settings") || "Check your device settings if camera is not appearing"}
          </p>
        )}
      </div>
      
      <Divider>{mrIntl("QRCodeLogin.or") || "OR"}</Divider>
      <div className={"back-to-login-link"}>
        <Link to={"/auth/login"} onClick={stopCamera}>{mrIntl("CommonText.go_back_to_login") || "Go back to login"}</Link>
      </div>
    </div>
  );
};


QRCodeLogin.defaultProps = {};

QRCodeLogin.propTypes = {};

export default QRCodeLogin;